module.exports = __webpack_public_path__ + "img/PMARRON.5b5a5376.jpg";